// Copyright 2026. WebPros International GmbH. All rights reserved.

export const ADD_TOAST = 'toaster/ADD_TOAST';
export const REMOVE_TOAST = 'toaster/REMOVE_TOAST';

// time in ms = 5s
export const FADE_TIMEOUT = 5000;
